export default __webpack_public_path__ + "static/media/fridge1-after2-1920w.4b425e78.avif";